import { takeEvery } from 'redux-saga/effects';
import { GET_INIT_PROVISIONAL_DATA } from './provisional-category.action';
import { getInitProvisionalSaga } from './provisional-category.saga';

export const provisionalCategorySaga = [
  takeEvery(GET_INIT_PROVISIONAL_DATA, getInitProvisionalSaga),
];
